import { MarketConfig } from '../../types/markets/MarketConfig';

export default new MarketConfig(
  'fr_BE',
  {
    fdidYouMean: false,
    ffacetNavigation: false,
    fdomainSuggestions: false,
    fvideo: false,
    fCommerceCarrossel: true,
    resultTiles: false,
    dealerWidget: false,
    frelatedsearch: false,
  },
  {
    fssInputCategory: true,
  },
  '87987a08-b586-44ff-b8b5-4004c958e5fb',
  ''
);
